import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { ContactInfoUpdateRequestDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';

type Req = {
  contactId: number;
  contactInfoId: number;
  dto: ContactInfoUpdateRequestDto;
  userId: string;
};

type Return = {
  isUpdating: boolean;
  updateCustomerContactInfo: (req: Req) => Promise<void>;
};

export const useUpdateCustomerContactInfo = (): Return => {
  const { contactsApi } = useApiClient();
  const queryClient = useQueryClient();

  const { isPending, mutateAsync } = useMutation<void, Return, Req>({
    mutationFn: async req => {
      await contactsApi.updateContactInfo(req.userId, req.contactId, req.contactInfoId, req.dto);
    },
    onSuccess: async (_data, req) => {
      await queryClient.refetchQueries({
        queryKey: [QueryKeyEnum.CONTACTS.DETAILS, req.contactId],
      });
    },
  });

  return {
    isUpdating: isPending,
    updateCustomerContactInfo: mutateAsync,
  };
};
